var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoricalDevelopmentLegends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.499,
    height: 128,
    viewBox: "0 0 171.499 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6758",
    "data-name": "Path 6758",
    d: "M3511,10074.374a8,8,0,1,1,8,8A8,8,0,0,1,3511,10074.374Zm36.5,3.5v-8h82v8Zm-36.5-40.5a8,8,0,1,1,8,8A8,8,0,0,1,3511,10037.376Zm36.5,3.5v-8h135v8Zm-36.5-40.5a8,8,0,1,1,8,8A8,8,0,0,1,3511,10000.374Zm36.5,3.5v-8h114v8Zm-36.5-41.5a8,8,0,1,1,8,8A8,8,0,0,1,3511,9962.376Zm36.5,4.5v-8h68v8Z",
    transform: "translate(-3511 -9954.375)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricalDevelopmentLegends);
export default __webpack_public_path__ + "static/media/historical_development_legends.f8f1e390.svg";
export { ForwardRef as ReactComponent };